import React from 'react';

import { Icon } from 'antd';

import moment from 'moment';

export default translationsStore => ({
  width: '100px',
  align: 'center',
  title: translationsStore.translate('lead.table.column.carStatus'),
  dataIndex: 'car.status',
  className: 'carStatus',
  render: (text, record) => {
    if (text === 'disconnected') {
      return text ? (
        <div>
          <Icon type="heart" className={`${text} shutdown`} />
          <div>{moment(record.car.lastConnection || record.car.createdAt).fromNow()}</div>
        </div>
      ) : (
        <span>&mdash;</span>
      );
    } else {
      return text ? <Icon type="heart" className={`${text} ${(record.car.shutdown === true) ? 'shutdown' : 'noshutdown'}`} /> : <span>&mdash;</span>;
    }
  }
});
